import { useEffect } from "react";

/**
 * Aplica manifest PWA e apple-touch-icon customizados para VAI PEDE
 * enquanto o usuário estiver nessas rotas (login/dashboard).
 * Restaura os valores originais ao desmontar (para não afetar outros produtos).
 */
export default function useVaipedeManifest() {
  useEffect(() => {
    const applied = [];

    // 1) manifest
    const manifestEl = document.querySelector('link[rel="manifest"]');
    const prevManifest = manifestEl?.getAttribute("href");
    if (manifestEl) {
      manifestEl.setAttribute("href", "/manifest-vaipede.json");
    } else {
      const l = document.createElement("link");
      l.rel = "manifest";
      l.href = "/manifest-vaipede.json";
      l.setAttribute("data-vp-injected", "1");
      document.head.appendChild(l);
      applied.push(l);
    }

    // 2) theme-color
    const themeEl = document.querySelector('meta[name="theme-color"]');
    const prevTheme = themeEl?.getAttribute("content");
    if (themeEl) {
      themeEl.setAttribute("content", "#EA1D2C");
    } else {
      const m = document.createElement("meta");
      m.name = "theme-color";
      m.content = "#EA1D2C";
      m.setAttribute("data-vp-injected", "1");
      document.head.appendChild(m);
      applied.push(m);
    }

    // 3) apple-touch-icon
    const oldApple = document.querySelectorAll('link[rel="apple-touch-icon"]');
    const prevApples = Array.from(oldApple).map(el => ({ el, href: el.getAttribute("href") }));
    oldApple.forEach(el => el.setAttribute("href", "/icons-vaipede/apple-touch-icon.png"));
    if (oldApple.length === 0) {
      const l = document.createElement("link");
      l.rel = "apple-touch-icon";
      l.href = "/icons-vaipede/apple-touch-icon.png";
      l.setAttribute("data-vp-injected", "1");
      document.head.appendChild(l);
      applied.push(l);
    }

    // 4) apple mobile web app title
    const appleTitle = document.querySelector('meta[name="apple-mobile-web-app-title"]');
    const prevAppleTitle = appleTitle?.getAttribute("content");
    if (appleTitle) {
      appleTitle.setAttribute("content", "VAI PEDE");
    } else {
      const m = document.createElement("meta");
      m.name = "apple-mobile-web-app-title";
      m.content = "VAI PEDE";
      m.setAttribute("data-vp-injected", "1");
      document.head.appendChild(m);
      applied.push(m);
    }

    // 5) title da aba
    const prevTitle = document.title;
    document.title = "VAI PEDE";

    return () => {
      // restaura
      if (manifestEl && prevManifest) manifestEl.setAttribute("href", prevManifest);
      if (themeEl && prevTheme) themeEl.setAttribute("content", prevTheme);
      prevApples.forEach(({ el, href }) => { if (href) el.setAttribute("href", href); });
      if (appleTitle && prevAppleTitle) appleTitle.setAttribute("content", prevAppleTitle);
      applied.forEach(el => el.parentNode?.removeChild(el));
      document.title = prevTitle;
    };
  }, []);
}
